import { createAsyncThunk } from '@reduxjs/toolkit'
import Profile from './profile-model'
import { delete_profile, load_profiles, store_profile } from './profile-service'

export const LoadProfilesAsync = createAsyncThunk<any, any>(
  'composer/load/profile',
  async (params: { uid: string }) => {
    return await load_profiles(params)
  },
)

export const CreateProfileAsync = createAsyncThunk<any, any>(
  'composer/create/profile',
  async (params: Profile) => {
    return await store_profile(params)
  },
)

export const DeleteProfileAsync = createAsyncThunk<any, any>(
  'composer/delete/profile',
  async (params) => {
    return await delete_profile(params)
  },
)
